/** Der Dialog zur Rueckfrage bei wiederkehrenden Aufgaben (F-24), einmal in der Huelle. */
import { ScopeDialog } from '@/modules/calendar/components/ScopeDialog';
import { useSerienFrage } from '@/modules/tasks/serienFrage';

export function SerienFrageHost() {
  const frage = useSerienFrage((s) => s.frage);
  return (
    <ScopeDialog
      open={frage !== null}
      art="aufgabe"
      mode={frage?.mode ?? 'bearbeiten'}
      ohneEinzeln={frage?.ohneEinzeln}
      onPick={(s) => frage?.antwort(s)}
      onCancel={() => frage?.antwort(null)}
    />
  );
}
